import * as Yup from 'yup';

import { validateApprovalPassword } from 'utils/validation';

import { FormValues } from './types';

export const initialValues: FormValues = {
  approvalPassword: '',
};

export const validationSchema = Yup.object().shape({
  approvalPassword: validateApprovalPassword,
});
